import { type FirebaseStorage, connectStorageEmulator, getStorage } from "firebase/storage"
import type { App, InjectionKey } from "vue"
import { isDemo } from "~/plugins/firebase"

declare module "vue" {
    interface ComponentCustomProperties {
        $storage: FirebaseStorage
    }
}

export const storageKey = Symbol() as InjectionKey<FirebaseStorage>
export const storage = {
    install: (app: App) => {
        const firebaseApp = app.config.globalProperties.$firebase
        const firebaseStorage = getStorage(firebaseApp)

        if (isDemo(firebaseApp)) {
            connectStorageEmulator(firebaseStorage, "localhost", 9199)
        }

        app.provide(storageKey, firebaseStorage)
        app.config.globalProperties.$storage = firebaseStorage
    }
}